// extracted by mini-css-extract-plugin
var _1 = "StepBody-module__hidden--z0Lrc";
var _2 = "StepBody-module__stepBody--GrHHU";
export { _1 as "hidden", _2 as "stepBody" }
